export * from './lib/data-tracking-events';
export { EventsDataTempateHelper, EventsDataTempateNames } from './lib/adapters/v1/helpers/data-template.helper';
